/* istanbul ignore file  -- query */
import { gql } from '@ori/fetching';

import { searchPreviewProduct } from './fragments';

export const searchPreviewQuery = gql`
  query SearchPreview($query: String!, $limit: Int = 12) {
    application {
      productSearchPreview {
        searchResults(query: $query, top: $limit) {
          totalProductsCount
          suggestions
          products {
            ...SearchPreviewProduct
          }
        }
      }
    }
  }
  ${searchPreviewProduct}
`;
